/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkActionSkip } from './bulkActionSkip';

/**
 * Per-id outcome summary for a bulk lifecycle action.
 */
export interface BulkEnrollmentActionResponse {
  succeeded?: string[];
  skipped?: BulkActionSkip[];
  /** @minimum 0 */
  succeeded_count?: number;
  /** @minimum 0 */
  skipped_count?: number;
}
